var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.getIsAuthenticated)?_c('div',{staticClass:"sidebar-links"},[_c('router-link',{class:{active: _vm.path === '/login'},attrs:{"to":"/login"}},[_vm._v("Login")]),_vm._v(" "),_c('router-link',{class:{active: _vm.path === '/registration'},attrs:{"to":"/registration"}},[_vm._v("Register an account")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431d272e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideNav/UnauthenticatedLinks.vue
// module id = null
// module chunks = 